<small class="debug">{{me}}</small>
<h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <button (click)="onCloseVerboseDialog()" mat-icon-button class="mini-button">
        <mat-icon>close</mat-icon>
    </button>
    <div class="dlg-drag-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
            <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" style="font-size: 1.6em">
        <app-scene-add-blocks (closedDialog)="onCloseVerboseDialog()" [addBlockType]="'BLOCK_COMPONENTS_VERBOSE'"></app-scene-add-blocks>
    </div>
</h1>
<br/>
<br/>





